import React from "react";
import "./styles.scss";
import { Link } from "react-router-dom";
import eventimg1 from "../../assets/images/events/event_thumb01.jpg";
import { LuCalendarDays } from "react-icons/lu";
import { LuMapPin } from "react-icons/lu";

export default function BlogCard(props) {
  const { path, url, title, description } = props;

  return (
    <Link to={path} style={{ textDecoration: "none" }}>
      <div className="blogcard-wrapper">
        <div className="blogs-thumb">
          <Link to={path} className="shine-animate">
            <img src={url} alt="img" />
          </Link>
          {/* <span className="events-date">
          <LuCalendarDays /> 25 May, 2023
        </span> */}
        </div>
        <Link to={path} style={{ textDecoration: "none" }}>
          <div className="blogs-content">
            <h4 className="title">
              <Link to={path}>{title}</Link>
            </h4>
            <p className="description">{description}</p>
            <span className="location">
              <LuMapPin /> India
            </span>
          </div>
        </Link>
      </div>
    </Link>
  );
}
